<ng-container *ngIf="!catalogsLoaded; else generalInfoContent">
  <div class="pod-skeleton">
    <div class="pod-skeleton__title"></div>
    <div class="pod-grid">
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
    </div>
  </div>
</ng-container>

<ng-template #generalInfoContent>
  <div class="pod-section" [formGroup]="form">

    <h2 class="pod-section__title">{{ sectionLabel }}</h2>

    <div class="pod-grid">

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.PURCHASE_ORDER_NAME)">
        <one-input
          [formControlName]="F.PURCHASE_ORDER_NAME"
          [label]="LABELS[F.PURCHASE_ORDER_NAME]"
        ></one-input>
        <span class="pod-field__error" *ngIf="isInvalid(F.PURCHASE_ORDER_NAME)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.SOURCE_TYPE)">
        <one-select
          #sourceTypeSelect
          *ngIf="selectSources[F.SOURCE_TYPE]"
          [config]="selectConfig"
          [dataSource]="selectSources[F.SOURCE_TYPE]"
          [label]="LABELS[F.SOURCE_TYPE]"
          [disabled]="sourceTypeSelectDisabled"
          (selectionChanged)="onSelectChange(F.SOURCE_TYPE, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.SOURCE_TYPE)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.MAKER_TO_EXECUTE)">
        <one-select
          #makerSelect
          [config]="makerSelectConfig"
          [dataSource]="selectSources[F.MAKER_TO_EXECUTE]"
          [label]="LABELS[F.MAKER_TO_EXECUTE]"
          (selectionChanged)="onMakerChange($event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.MAKER_TO_EXECUTE)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isPoTypeVisible" [class.pod-field--error]="isInvalid(F.PO_TYPE)">
        <one-select
          #poTypeSelect
          *ngIf="selectSources[F.PO_TYPE]"
          [config]="selectConfig"
          [dataSource]="selectSources[F.PO_TYPE]"
          [label]="LABELS[F.PO_TYPE]"
          (selectionChanged)="onSelectChange(F.PO_TYPE, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.PO_TYPE)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.OWNER)">
        <one-select
          #ownerSelect
          [config]="searchSelectConfig"
          [dataSource]="selectSources[F.OWNER]"
          [label]="LABELS[F.OWNER]"
          (selectionChanged)="onSelectChange(F.OWNER, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.OWNER)">*Required</span>
      </div>

      <div class="pod-field" *ngIf="isParentPoVisible">
        <one-input
          [formControlName]="F.PARENT_PO"
          [label]="LABELS[F.PARENT_PO]"
        ></one-input>
      </div>

    </div>
  </div>
</ng-template>
